import { ZodSchema } from "zod";
import { DataContextComponent } from "./data-context-component.js";
import { FrameComponent } from "../frames/frame-component.js";
import schemaRegistry from "../../logic/schemaRegistry.js";
import { toastError, toastSuccess } from "../../toasts.js";
import { ApiResponse } from "@bonusmap/api-types";
import { casingUtils, isNumber } from "@bonusmap/shared_ui/library";


export class DataRemove extends DataContextComponent {
    static webComponentName: string = "data-remove";
    protected _templateId: string = ""; // No template needed
    private _schema: ZodSchema<any> | null = null;
    private ConfirmBtn!: HTMLButtonElement;
    private CancelBtn!: HTMLButtonElement;
    constructor() {
        super();
    }
    get frameController(): FrameComponent | null {
        return window.frameController || null;
    }
    public get rowId(): number {
        const attrVal = this.getAttribute(`data-id`);
        if (attrVal) {
            const valNum = parseInt(attrVal);
            if (isNumber(valNum)) {
                return valNum;
            }
        }
        return 0
    }
    get toastError(): typeof toastError {
        if (this.frameController) return this.frameController.toastError;
        return toastError;
    }
    get toastSuccess(): typeof toastSuccess {
        if (this.frameController) return this.frameController.toastSuccess;
        return toastSuccess;
    }
    get schema(): ZodSchema<any> | null {
        if (!this._schema) {
            let schemaKey = (this.getAttribute('schema') || '').toLowerCase();
            if (this.action === "add" && schemaKey) {
                schemaKey += "-no-id";
            }
            if (schemaKey && schemaRegistry && schemaKey in schemaRegistry) {
                this._schema = schemaRegistry[schemaKey];
            } else {
                console.warn(`DataRemove: No schema found for key "${schemaKey}"`);
            }
        }
        return this._schema;
    }
    get apiName(): string {
        let schemaKey = (this.getAttribute('schema') || '').toLowerCase();
        return casingUtils.toCamelCase(schemaKey)
    }
    private frameClose(): void {
        if (this.frameController) {
            
            this.frameController.close();
        }
    }
    private async onConfirm(): Promise<void> {
        const id = this.rowId;
        if (!id || id <= 0) {
            this.toastError("ID non valido per l'eliminazione");
            return;
        }
        const api: any = (window as any).api?.manager?.[this.apiName];
        if (api) {
            const result: ApiResponse<any> | null = await api.delete(id);
            if (result && result.success) {
                this.toastSuccess(`Elemento eliminato con successo (id: ${id})`);
                this.frameController!.actionExecuted = true;
                this.frameClose();
            }
            else {
                const msg = result?.message || "Errore sconosciuto";
                this.toastError(`Errore durante l'eliminazione: ${msg}`);
            }
        }
        else {
            this.toastError(`API ${this.apiName} non disponibile per l'eliminazione`);
        }
    }
    private onCancel(): void {
        this.toastError("Operazione annullata");
        this.frameClose();
    }
    private setupEventListeners(): void {
        this.ConfirmBtn?.addEventListener('click', this.onConfirm.bind(this));
        this.CancelBtn?.addEventListener('click', this.onCancel.bind(this));
    }
    protected render(): void {
        // qui non c'è nessun template da renderizzare
        this.ConfirmBtn = this.roleElementSelector('confirm') as HTMLButtonElement;
        this.CancelBtn = this.roleElementSelector('cancel') as HTMLButtonElement;
        this.setupEventListeners();
    }
}